import AppRouter from "../approuter/AppRouter";

export default function Content() {
  return (
    <AppRouter />
  );
}
